import { Box, Typography, Container } from "@mui/material";
import wallpaper from '../assets/iwata.png';
import wallpaper2 from '../assets/leaf.jpg';

const ResponsivePage = () => {
  return (
    <Container
      disableGutters
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#fff",
      }}
    >
      {/* 左側：タイトルエリア */}
      <Box
        sx={{
          flex: 1, 
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          position: "relative",
          backgroundImage: `url(${wallpaper2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          marginTop: { xs: "64px", md: 0 }, // ヘッダー分
          minHeight: { xs: "160px", md: "auto" }, 
        }}
      >
        <Box
          sx={{
            position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.2)", // 👈 少し暗くして文字を読みやすく
            backdropFilter: "blur(5px)",
            zIndex: 1,
          }}
        />
        <Box sx={{ position: "relative", zIndex: 2, color: "white" }}>
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: "28px", md: "40px" },
              fontWeight: "bold",
              fontFamily: "'Noto Serif JP', serif",
              textShadow: "1px 1px 10px rgba(0,0,0,0.2)",
            }}
          >
            Message
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: "0.9rem", md: "1.4rem" }, 
              fontWeight: 'bold',
              fontFamily: "'Noto Serif JP', serif",
              textShadow: "1px 1px 10px rgba(0,0,0,0.2)",
            }}
          >
            代表メッセージ
          </Typography>
        </Box>
      </Box>

      {/* 右側：コンテンツエリア */}
      <Box
        sx={{
          flex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: { xs: "20px 16px", md: 4 },
          // 👈 これでXRでは中央、SEでは上から詰めて配置
          my: 'auto',
        }}
      >
        <Box
          component="img"
          src={wallpaper}
          alt="代表近影"
          sx={{
            // 👈 SEで顔写真が大きすぎないよう調整
            width: { xs: "150px", md: "220px" },
            borderRadius: 2,
            boxShadow: 2,
            marginBottom: { xs: 1.5, md: 3 },
          }}
        />
        
        <Box sx={{ width: "100%", maxWidth: "700px" }}>
          <Typography
            variant="body1"
            component="div" 
            sx={{
              lineHeight: { xs: 1.5, md: 1.9 },
              textAlign: "left",
              fontFamily: "'Noto Serif JP', serif",
              // 👈 SEでギリギリにならないようフォントサイズを微調整
              fontSize: { xs: "13px", md: "16px" },
              fontWeight: 500, // 700だと重いので500に
              px: { xs: 1, md: 5 },
            }}
          >
            「あなたの物語（経験）を次の時代へ」
            <br /><br />
            人が過去に経験してきたことの価値は、色あせず無くならない。
            私は皆さんが過去に経験された物語に魅力を感じ、それを活かしていきたいと考えております。
            <br />
            そして、新しい価値とサービスを作り上げていく。
            <br />
            是非、皆さんの貴重な経験を我が社で活かし、新しい物語を作り上げていきましょう。
            お力をお貸しください。
            
            <Box sx={{ textAlign: "right", width: "100%", mt: 2, fontSize: "0.9em" }}>
              NextEpisode<br />代表取締役　岩田鮎
            </Box>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default ResponsivePage;
